import { useState, useRef } from "react";
import React from "react";

import { Col, Modal, ModalBody, Row, Label, Alert } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

import "./ModalInforme.css";
import "reactjs-popup/dist/index.css";

import "./sigCanvas.css";

import Modalfirma from "./Modalfirma";
import {
  informesUpdate,
 
  informesCreate,
  
} from "../../store/informes/actions";
import { useDispatch, useSelector } from "react-redux";




import { casosUpdate,casosList } from "../../store/casos/actions";
import Imagenes from "./ComponentsModalinforme/Imagenes";
import { informesList } from "../../store/informes/actions";
const ModalInforme = (props) => {
  const dispatch = useDispatch();
  const URL = process.env.REACT_APP_API_URL.split("/api").join("");
  
  const handleButtonClick = () => {
    props.onCloseClick(); // Llama a la función onCloseClick pasada como prop desde el componente padre
  };


  const stateerror = useSelector(state=>state.Informes.error)
  console.log(props)
  const [Informe] = Array.isArray(props.NumeroInforme)
    ? props.NumeroInforme
    : [null];

 

  const [image, setFormDataImage] = useState([]);

  const [imageUrl, setImageUrl] = useState(null);

  const [imageUrl1, setImageUrl1] = useState(null);

  const sigCanvas = useRef(null);
 
  const [formData, setFormData] = useState({
    informe_visita: Informe ? Informe.informe_visita : "",
    repuesto_materiales: Informe ? Informe.repuesto_materiales : "",
    observaciones: Informe ? Informe.observaciones : "",
    cargo_persona_recibe_servicio: Informe
      ? Informe.cargo_persona_recibe_servicio
      : "",
    persona_recibe_servicio: Informe ? Informe.persona_recibe_servicio : "",
  });

  const {
    informe_visita,
    repuesto_materiales,
    observaciones,
    cargo_persona_recibe_servicio,
    persona_recibe_servicio,
  } = formData;

  const onChange = (e) => {
    const uppercaseValue = e.target.value.toUpperCase();
    setFormData({ ...formData, [e.target.name]: uppercaseValue });

    const textarea = e.target;
    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
  };

  const handleImageChange = (evImages) => {
    Array.from(evImages).forEach((image) => {
      var reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = function () {
        var img = [];
        var base64 = reader.result;
        img = base64.split(",");
        setFormDataImage((prevImages) => [...prevImages, { image: img[1] }]);
      };
    });
  };

  // Funciones para la firma

  const limpiar = () => sigCanvas.current.clear();

  const guardar = () => {
    const imageUrl = sigCanvas.current.toDataURL("image/png");
    const cleanImageUrl = imageUrl.substring("data:image/png;base64,".length);
    setImageUrl(cleanImageUrl);
    setImageUrl1(imageUrl);
    handleClose();
  };

  const [FirmaModal, setFirmaModal] = useState(false);

  const handleFirmaModal = () => {
    setFirmaModal(true);
  };

  const handleCloseFirmaModal = () => {
    setFirmaModal(false);
  };
  function handleClose() {
    // popupRef.current.close();
    setFirmaModal(false);
  }


  // Funciones para Manejar Caso

  const handleCaso = (e) => {
    dispatch(
      casosUpdate(`${props.Item.id}`, {
        estatus: "FINALIZAR",
      })
    );
  };

  // Funciones para Crear Informe

  const handleCrear = (e) => {
    const data = {
      informe_visita,
      repuesto_materiales,
      observaciones,
      persona_recibe_servicio,
      cargo_persona_recibe_servicio,
      caso: props.Item.id,

      estatus_informe: "",
      images: image,
    };

    if (imageUrl !== null) {
      data.firma = imageUrl;
    } else {
      data.firma = [];
    }

    dispatch(informesCreate(data));

    console.log(data);
  };

  const handleEditar = (e) => {
    const data = {
      informe_visita,
      repuesto_materiales,
      observaciones,
      persona_recibe_servicio,
      cargo_persona_recibe_servicio,

      caso: Informe.caso,
      estatus_informe: "",
    };

    if (image.length !== 0) {
      data.images = image;
    }

    // Funcion para la Firma
    if (imageUrl !== null) {
      data.firma = imageUrl;
    } else {
      if (Informe.firma === "") {
        data.firma = [];
      } else {
        const url = `${URL}${Informe.firma}`;

        const convertirImagenABase64 = () => {
          return new Promise((resolve, reject) => {
            fetch(url)
              .then((response) => response.blob())
              .then((blob) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                  const base64data = reader.result;
                  resolve(base64data);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
              })
              .catch((error) => {
                reject(error);
              });
          });
        };

        convertirImagenABase64()
          .then((base64data) => {
            // console.log(base64data);
            const imageData = base64data.split(",")[1];
            data.firma = imageData;
            // Aquí puedes continuar con el resto del código que depende de data.firma

            console.log(data);
          })
          .then(() => {
            dispatch(informesUpdate(Informe.id, data));
          })
          .catch((error) => {
            console.error("Error al convertir la imagen a base64:", error);
          });
      }
    }
    // Funcion para la Firma
    dispatch(informesUpdate(Informe.id, data));
  };

  const state = useSelector((state) => state);
  const InformeCopIma = Informe ? Informe.images : [];






  return (
    <React.Fragment>
      {state.Informes.informesUpdated.id ? (
        <SweetAlert
          title="Hecho!"
          success
          timeout={1000}
          showConfirm={false}
          onConfirm={() => {
         dispatch(informesList())
         dispatch(casosList())
        
            handleButtonClick();
          }}
        >
          Se ha Actualizado el Informe
        </SweetAlert>
      ) : null}
      {state.Informes.informesCreated.id ? (
        <SweetAlert
          title="Hecho!"
          success
          timeout={1000}
          showConfirm={false}
          onConfirm={() => {
            dispatch(informesList())
            handleButtonClick();
            dispatch(casosList())
          }}
        >
          Se ha Creado el Informe
        </SweetAlert>
      ) : null}

      {FirmaModal ? (
        <Modalfirma
          FirmaModal={FirmaModal}
          onCloseClick={handleCloseFirmaModal}
          handleClose={handleClose}
          limpiar={limpiar}
          guardar={guardar}
          sigCanvas={sigCanvas}
        ></Modalfirma>
      ) : null}

      <Modal
        isOpen={props.InformeModal}
        toggle={props.onCloseClick}
        centered={true}
      >
        <div className="modal-header">
          <h3 className="modal-title mt-2">
            {props.NumeroInforme ? "EDITAR " : "CREAR "}
            INFORME
          </h3>
          <button
            type="button"
            onClick={() => {
              handleButtonClick();
            }}
            className="close button-cerrar "
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">X</span>
          </button>
        </div>

        <ModalBody>
          <Row>
            <Col lg={12} className="mb-3">
              <Label for="first_name" className="form-label">
                INFORME VISITA
              </Label>

              <textarea
                className="form-control text-area"
                id="informe_visita"
                name="informe_visita"
                type="textarea"
                rows="4"
                onChange={onChange}
                value={informe_visita}
              />
              
{stateerror && stateerror.persona_recibe_servicio ? (
                <Alert color="danger" className="mt-2">
                  {stateerror.informe_visita}
                </Alert>
              ) : null}
            </Col>
          </Row>

          <Row className="col-lg-12 justify-content-center">
            <Col lg={12} className="mb-10">
              <Label
                for="repuesto_materiales"
                className="col-form-label col-sm-4 d-flex"
              >
                <strong>Repuestos y/o Materiales </strong>
              </Label>

              <textarea
                className="form-control text-area"
                id="repuesto_materiales"
                name="repuesto_materiales"
                type="textarea"
                rows="4"
                onChange={onChange}
                value={repuesto_materiales}
              />
             
            </Col>
          </Row>

          <Row className="col-lg-12 justify-content-center">
            <Col lg={12} className="mb-10">
              <Label
                for="observaciones"
                className="col-form-label col-sm-4 d-flex"
              >
                <strong>Observaciones</strong>
              </Label>

              <textarea
                className="form-control"
                id="observaciones"
                name="observaciones"
                type="textarea"
                rows="4"
                onChange={onChange}
                value={observaciones}
              />
            </Col>
          </Row>
          

          <Row className="col-lg-12 justify-content-center">
            <Col lg={12} className="mb-10">
              <Label for="image" className="col-form-label col-sm-4 d-flex">
                <strong>Imagenes (Opcional) </strong>
              </Label>

              <input
                className="form-control"
                id="image"
                name="image"
                type="file"
                multiple={true}
                onChange={(e) => handleImageChange(e.target.files)}
              />
            </Col>
          </Row>
 

         
          <Imagenes
          Informe={Informe}
          InformeCopIma={InformeCopIma}
          handleButtonClick={handleButtonClick}
          >

          </Imagenes>
          

          <Row className="col-lg-12 justify-content-center">
            <Col lg={6} className="mb-10">
              <Label
                for="persona_recibe_servicio"
                className="col-form-label col-sm-6 d-flex"
              >
                <strong>Persona Contacto</strong>
              </Label>

              <input
                className="form-control"
                id="persona_recibe_servicio"
                name="persona_recibe_servicio"
                type="text"
                onChange={onChange}
                value={persona_recibe_servicio}
              />
             

{stateerror && stateerror.persona_recibe_servicio ? (
                <Alert color="danger" className="mt-2">
                  {stateerror.persona_recibe_servicio}
                </Alert>
              ) : null}
            </Col>

            <Col lg={6} className="mb-10">
              <Label
                for="cargo_persona_recibe_servicio"
                className="col-form-label col-sm-4 d-flex"
              >
                <strong>Cargo</strong>
              </Label>

              <input
                className="form-control"
                id="cargo_persona_recibe_servicio"
                name="cargo_persona_recibe_servicio"
                type="text"
                onChange={onChange}
                value={cargo_persona_recibe_servicio}
              />
              {stateerror && stateerror.cargo_persona_recibe_servicio ? (
                <Alert color="danger" className="mt-2">
                  {stateerror.cargo_persona_recibe_servicio}
                </Alert>
              ) : null}
            </Col>

            <button onClick={handleFirmaModal} className="button-firma">
              Firma
            </button>

            {imageUrl1 ? (
              <Row className="row-firma">
                <img
                  src={imageUrl1}
                  alt="mi firma"
                  style={{
                    display: "block",
                    margin: "0 auto",
                    border: "1px solid blick",
                    width: "150px",
                  }}
                />
              </Row>
            ) : null}

            <Row className="mt-2">
              {Informe ? (
                Informe.firma !== "" ? (
                  <Row className="justify-content-around">
                    <img
                      src={`${URL}${Informe.firma}`}
                      alt="mi firma"
                      style={{
                        display: "block",
                        margin: "10px  auto",
                        border: "2px dashed #000000",
                        width: "350px",
                        backgroundColor: "white",
                      }}
                    />
                  </Row>
                ) : null
              ) : null}
            </Row>
          </Row>

          <Row>
          {props.NumeroInforme && props.NumeroInforme.length > 0 ? (
  <Col>
    <button className="button-guardar " onClick={handleEditar}>
      GUARDAR
    </button>
    <button className="button-guardar " onClick={handleCaso}>
      FINALIZAR CASO
    </button>
  </Col>
) : (
  <button onClick={handleCrear} className="button-guardar ">
    CREAR
  </button>
)}
          </Row>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default ModalInforme;
